<div class="dialog-senha">
  <h2>Alterar senha</h2>
  <form [formGroup]="senhaForm" (ngSubmit)="salvar()" autocomplete="off">
    <mat-form-field appearance="outline">
      <mat-label>Senha atual</mat-label>
      <input matInput [type]="esconderSenhaAtual ? 'password' : 'text'" formControlName="senhaAtual"
        autocomplete="current-password">
      <button mat-icon-button matSuffix type="button" tabindex="-1" (click)="esconderSenhaAtual = !esconderSenhaAtual"
        [attr.aria-label]="esconderSenhaAtual ? 'Mostrar senha atual' : 'Ocultar senha atual'"><mat-icon>{{
          esconderSenhaAtual ? 'visibility' : 'visibility_off' }}</mat-icon></button>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Nova senha</mat-label>
      <input matInput [type]="esconderNovaSenha ? 'password' : 'text'" formControlName="novaSenha"
        autocomplete="new-password" (blur)="validarConfirmacao()">
      <button mat-icon-button matSuffix type="button" tabindex="-1" (click)="esconderNovaSenha = !esconderNovaSenha"
        [attr.aria-label]="esconderNovaSenha ? 'Mostrar nova senha' : 'Ocultar nova senha'"><mat-icon>{{
          esconderNovaSenha ? 'visibility' : 'visibility_off' }}</mat-icon></button>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Repetir nova senha</mat-label>
      <input matInput [type]="esconderConfirmacao ? 'password' : 'text'" formControlName="confirmarNovaSenha"
        autocomplete="new-password" (blur)="validarConfirmacao()">
      <button mat-icon-button matSuffix type="button" tabindex="-1" (click)="esconderConfirmacao = !esconderConfirmacao"
        [attr.aria-label]="esconderConfirmacao ? 'Mostrar confirmação' : 'Ocultar confirmação'"><mat-icon>{{
          esconderConfirmacao ? 'visibility' : 'visibility_off' }}</mat-icon></button>
      <mat-error *ngIf="senhaForm.controls.confirmarNovaSenha.hasError('diferente')">As senhas não conferem.</mat-error>
    </mat-form-field>
    <div class="dialog-senha__acoes">
      <button mat-button type="button" (click)="cancelar()" [disabled]="salvando">Cancelar</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="salvando">Salvar</button>
    </div>
  </form>
</div>
